import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-request-org-success',
  templateUrl: './request-org-success.component.html',
  styleUrls: ['./request-org-success.component.scss'],
})
export class RequestOrgSuccessComponent implements OnInit {

  @Input() org: any;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {}

  dismiss(){
    this.modalController.dismiss();
  }

}
